























































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { CustomerSchema } from "@/models/customer_schema";
import { Address } from "@/models/address";
import CustomerService from "../../services/customer_service";
import GeocodeService from "../../services/geocode_service";
import states from "@/map_data/state-abbrv";
import provinces from "@/map_data/prov-abbrv";
import { getCountries } from "@/store/modules/customer/getters";
import { StoreModule } from "@/store/types";
import { CustomerActions } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import SalesRegionToRepMap from "@/models/map/region_rep";
import BrandMap from "@/models/brand_map";
import Datepicker from "vuejs-datepicker";
import { SalesContactSchema } from "@/models/sales_contact_schema";
import { CustomerType, CustomerStatus } from "@/models/customer";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { phone } from "@/validators/custom";
import { Validation } from "vuelidate";
import { EventBus } from "@/events/index";
import { Layers } from "@/models/map/layers";
import { GlobalGetters } from "@/store/modules/global/types";
import { Roles } from "@/models/roles";
import { UserGetters } from "@/store/modules/user/types";

import {
  AuthError,
  APIError,
  GenericError,
  GeocodeError,
} from "@/services/error_service";
import { Brand } from "@/models/brands_schema";

@Component({
  components: {
    Datepicker,
  },
})
export default class ModalCustomer extends Vue {
  @Prop() isEdit!: boolean;
  @Prop() data!: CustomerSchema;
  protected submit = false;
  protected formData = {
    address: {} as Address,
    location: { type: "Point", coordinates: [] as number[] },
  } as CustomerSchema;
  protected longitude: number | string = "TBD";
  protected latitude: number | string = "TBD";
  protected overrideCoords = false;
  protected contacts = {} as SalesContactSchema;
  protected salesRegions: { rep: string; region: string }[] = [];
  protected selectedBrands: string[] = [];
  protected brandsDisplay: string[] = [];
  protected customerService = new CustomerService();
  protected geocodeService = new GeocodeService();
  protected CustomerType = CustomerType;
  protected CustomerStatus = CustomerStatus;
  protected BrandMap = BrandMap;
  protected $v: Validation;
  protected country = "USA";
  protected Layers = Layers;
  protected Roles = Roles;
  protected showStateRequired = true;
  protected showPostalRequired = true;
  protected showNewCountryField = false;
  protected newCountry = '';
  protected countryError = '';
  protected sessionAddedCountries: string[] = [];


  @(namespace(StoreModule.Customer).Action(CustomerActions.AddCustomer))
  addCustomer;
  @(namespace(StoreModule.Customer).Action(CustomerActions.EditCustomer))
  editCustomer;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  activeView;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.User).Getter(UserGetters.GetUser)) user;

  /** ALl custom validations should evaluate to true to submit form. Invalid = false */
  @Validations()
  validations() {
    const baseValidations = {
      longitude: {
        isLongitude: (value) => {
          if (this.overrideCoords) {
            return isFinite(value) && Math.abs(value) <= 180;
          } else {
            return true;
          }
        },
        isReq: (value) => {
          if (!value && this.overrideCoords) {
            return false;
          } else {
            return true;
          }
        },
      },
      latitude: {
        isLatitude: (value) => {
          if (this.overrideCoords) {
            return isFinite(value) && Math.abs(value) <= 90;
          } else {
            return true;
          }
        },
        isReq: (value) => {
          if (!value && this.overrideCoords) {
            return false;
          } else {
            return true;
          }
        },
      },
      country: { required },
      formData: {
        customer_name: { required },
        phone: { required, phone },
        sales_region: { required },
        address: {
          address_1: { required },
          city: { required },
          state: {
            stateReq: (value) => {

              if ((this.country === "USA" || this.country === "Canada")) {
                return !!value; 
              }
              return true;
            }
          },
          postal_code: {
              postalReq: (value) => {
                // Only validate if country is USA/Canada
                if (this.country === "USA" || this.country === "Canada") {
                  return !!value; 
                }
                return true; 
              }
            },
        },
        customer_type: { required },
        status: { required },
        email: {
          email,
        },
      },
    };

    if (this.isEdit) {
      return baseValidations;
    } else if (this.salesContactFilledOut) {
      return {
        ...baseValidations,
        contacts: {
          first_name: { required },
          last_name: { required },
          email: { required, email },
        },
      };
    } else {
      return baseValidations;
    }
  }

  created() {
    this.setSalesRegionArray();
    this.prepFormData();
  }

  public prepFormData(): void {
    if (this.activeView !== Layers.Customers) {
      this.setDefaultsNonRetail();
    }
    if (this.isEdit) {
      this.populateFormFields();
    } else if (this.role === Roles.SalesRep) {
      this.formData.sales_region = this.user.rep_info.sales_region;
      this.formData.hide_from_map = true;
    }
  }

  public populateFormFields(): void {
    this.formData = { ...this.data };
    this.formData.address = { ...this.data.address };
    this.formData.location = { ...this.data.location };
    if (this.data.brands_carried) {
      this.data.brands_carried.forEach((brand) => {
        this.selectedBrands.push(brand.handle);
      });
    }
    this.longitude = this.formData.location.coordinates[0];
    this.latitude = this.formData.location.coordinates[1];
    this.country = this.formData.address.country;
    this.updateRequiredIndicators();
  }

  public setDefaultsNonRetail() {
    this.formData.sales_region = "Unassigned";
    if (!this.isEdit) {
      if (this.activeView === Layers.Contract) {
        this.formData.customer_type = CustomerType.Contract;
      } else if (this.activeView === Layers.Beach) {
        this.formData.customer_type = CustomerType.BeachConcession;
      }
    }
  }

  public handleCountryChange(): void {
    this.$v.country.$touch();
    this.formData.address.country = this.country;
    this.updateRequiredIndicators();
    
    if (this.country !== "USA" && this.country !== "Canada") {
      this.formData.address.state = "";
      this.formData.address.postal_code = ""; // Clear postal code
      this.$v.formData.address.state.$reset();
      this.$v.formData.address.postal_code.$reset();
    }
  }

  public clearNewCountry(): void {
    this.country = '';
    this.countryError = '';
    this.showNewCountryField = false;
  }

  private updateRequiredIndicators(): void {
    this.showStateRequired = this.country === 'USA' || this.country === 'Canada';
    this.showPostalRequired = this.country === 'USA' || this.country === 'Canada';
    
    // Reset validation when country changes to non-USA/Canada
    if (!(this.country === 'USA' || this.country === 'Canada')) {
      this.$v.formData.address.state.$reset();
      this.$v.formData.address.postal_code.$reset();
    }
  }

  @Watch("country")
  private onCountryChange(): void {
    this.handleCountryChange();
  }

  @Watch("selectedBrands", { immediate: true })
  private onBrandChange(): void {
    this.brandsDisplay = [];
    this.selectedBrands.forEach((brand) => {
      this.brandsDisplay.push(" " + BrandMap.get(brand));
    });
  }

  public makeTitleCase(option: string) {
    return option.toLowerCase().split(' ').map(function(word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }

  get salesContactFilledOut(): boolean {
    if (
      this.contacts.email ||
      this.contacts.first_name ||
      this.contacts.last_name
    ) {
      return true;
    } else {
      return false;
    }
  }

  get CustomerStatusOptions(): CustomerStatus[] {
    let options;
    if (this.activeView === Layers.Customers) {
      options = CustomerStatus;
    } else {
      options = [
        CustomerStatus.Current,
        CustomerStatus.FrankfordTarget,
        CustomerStatus.Lost,
      ];
    }
    return options;
  }

  get CustomerTypeOptions(): CustomerType[] {
    let options;
    if (
      (this.activeView === Layers.Customers && !this.isEdit) ||
      this.role === Roles.SalesRep
    ) {
      options = [this.CustomerType.Customer, this.CustomerType.Designer];
    } else {
      options = CustomerType;
    }
    return options;
  }

  get zipMask(): string {
    if (!this.country) return "";
    let mask;
    if (this.country === "Canada") {
      mask = "A#A #A#";
    } else if (this.country === "USA") {
      mask = "#####";
    } else {
      mask = ""; // No mask for other countries
    }
    return mask;
  }

  get states(): string[] {
    let list = ["--"];
    if (this.country === "Canada") {
      list = provinces;
    } else if (this.country === "USA") {
      list = states;
    }
    return list;
  }

  get countries(): string[] {
    const storeCountries = getCountries(this.$store.state.customer);
    const allCountries = [...storeCountries, ...this.sessionAddedCountries];
    
    // De-duplicate and sort
    const uniqueCountries = Array.from(new Set(allCountries));
    const mainCountries = ['USA', 'Canada'];
    const otherCountries = uniqueCountries
      .filter(c => !mainCountries.includes(c))
      .sort((a, b) => a.localeCompare(b));
    
    return [...mainCountries, ...otherCountries];
  }

  public setSalesRegionArray(): void {
    for (const [key, value] of SalesRegionToRepMap.entries()) {
      this.salesRegions.push({ rep: key, region: value });
    }
  }

  public makeSentenceCase(option: string) {
    return option.charAt(0).toUpperCase() + option.slice(1);
  }

  public handleBrands(): Brand[] {
    const array: Brand[] = [];
    this.selectedBrands.forEach((brand) => {
      array.push({ handle: brand, display_name: BrandMap.get(brand) });
    });
    return array;
  }

  public handleSubmit(): void {
    this.$v.formData.$touch();
    if (!this.isEdit && this.salesContactFilledOut) {
      this.$v.contacts.$touch();
    }
    if (this.overrideCoords) {
      this.$v.longitude.$touch();
      this.$v.latitude.$touch();
    }
    if (!this.$v.$invalid) {
      this.submitForm();
    }
  }

  public submitForm(): void {
    const autoGenCoords = this.detectAutoGenCoords();
    if (this.overrideCoords) {
      this.formData.location.coordinates = [
        this.longitude as number,
        this.latitude as number,
      ];
    }
    this.formData.address.country = this.country;
    if (this.selectedBrands.length > 0) {
      this.formData.brands_carried = this.handleBrands();
    } else {
      this.formData.brands_carried = [];
    }
    if (autoGenCoords) {
      this.getGeocodeCoords();
    } else if (this.isEdit) {
      const newStatus = this.detectStatusChange();
      this.submitUpdatedCustomer(newStatus);
    } else {
      this.submitNewCustomer();
    }
    if (!(this.country === 'USA' || this.country === 'Canada') && !this.formData.address.postal_code) {
      this.formData.address.postal_code = ''; 
    }
  }

  public detectAutoGenCoords(): boolean {
    let geocode = true;
    if (this.overrideCoords) {
      geocode = false;
    } else if (this.isEdit) {
      geocode = this.detectAddressChange();
    }
    return geocode;
  }

  public detectAddressChange() {
    let change = false;
    const fields = ["city", "country", "state", "postal_code", "address_1"];
    fields.forEach((field) => {
      if (this.data.address[field] !== this.formData.address[field]) {
        change = true;
      }
    });
    return change;
  }

  public detectStatusChange() {
    let change = false;
      if (this.data.status !== this.formData.status) {
        change = true;
      }
    return change;
  }

  public async submitUpdatedCustomer(addMarker?: boolean): Promise<void> {
    try {
      await this.customerService.updateCustomer(this.formData, this.data._id);
      this.editCustomer(this.formData);
      if (addMarker || this.overrideCoords) {
        EventBus.$emit("addNewMarker", this.formData, true);
      }
      this.moveOnUpdate(this.data._id);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public async getGeocodeCoords(): Promise<void> {
    const query = {
      street: this.formData.address.address_1,
      city: this.formData.address.city,
      state: this.formData.address.state || '',
      postalCode: (this.country === 'USA' || this.country === 'Canada') 
        ? this.formData.address.postal_code.toString()
        : '',
      country: this.formData.address.country
    };
    try {
      const coords = await this.geocodeService.getGeocode(query);
      this.formData.location.coordinates = [coords.lng, coords.lat];
      if (this.isEdit) {
        this.submitUpdatedCustomer(true);
      } else {
        this.submitNewCustomer();
      }
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof GeocodeError) {
        GeocodeError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public async submitNewCustomer(): Promise<void> {
    try {
      if (this.salesContactFilledOut) {
        this.formData.sales_contacts = [this.contacts];
      } else {
        this.formData.sales_contacts = undefined;
      }
      const res = await this.customerService.createNewCustomer(this.formData);
      this.addCustomer(res);
      EventBus.$emit("addNewMarker", res);
      this.moveOnUpdate(res._id);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  protected moveOnUpdate(id: string): void {
    if (this.$route.params.id !== id.toString() || !this.$route.params.id) {
      this.$router.push({ path: "/customers/" + id });
    } else {
      EventBus.$emit("moveToCustomer");
    }
    this.$emit("close");
  }

protected handleAddNewCountry(): void {
  this.showNewCountryField = true;
  this.country = '';
  this.$nextTick(() => {
    const newCountryInput = this.$el.querySelector('#newCountryInput') as HTMLInputElement;
    if (newCountryInput) newCountryInput.focus();
  });
}

  protected validateNewCountry(): void {
  this.countryError = '';
  const countryName = this.newCountry.trim();
  
  if (!countryName) {
    this.countryError = 'Country name is required';
    return;
  }
  
  if (countryName.length > 50) {
    this.countryError = 'Country name too long (max 50 characters)';
    return;
  }
  
  const normalizedNew = countryName.toLowerCase();
  const exists = this.countries.some(c => c.toLowerCase() === normalizedNew);
  
  if (exists) {
    this.countryError = 'Country already exists';
    return;
  }
  
  // If validation passes
  this.country = countryName;
  this.formData.address.country = countryName;
  this.handleCountryChange();
}

protected handleCountrySelectChange(e: Event): void {
  const target = e.target as HTMLSelectElement;
  if (target.value === 'addNew') {
    this.handleAddNewCountry();
  } else {
    this.handleCountryChange();
  }
}

}
